import { render, staticRenderFns } from "./SimpleFnolListCard.vue?vue&type=template&id=47f54603&"
import script from "./SimpleFnolListCard.vue?vue&type=script&lang=js&"
export * from "./SimpleFnolListCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports